import {
    CheckSquareOutline,
    BorderOutline,
    DisconnectOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    DashboardOutline,
    UserOutline,
    LockOutline,
    ApiOutline,
    AppstoreOutline,
    SafetyCertificateOutline,
    LogoutOutline,
    BellOutline,
    SettingOutline,
    HomeOutline,
    PlusOutline,
    EditOutline,
    DeleteOutline,
    CheckCircleOutline,
    CloseCircleOutline,
    InfoCircleOutline,
    WarningOutline,
    SearchOutline,
    ReloadOutline,
    TeamOutline,
    FileTextOutline,
    BarChartOutline,
    CloudUploadOutline,
    CloudDownloadOutline,
    FileDoneOutline,
    RiseOutline,
    ClockCircleOutline,
    ExclamationCircleOutline,
    ThunderboltOutline,
    TagOutline,
    QuestionCircleOutline,
    MinusCircleOutline,
    MailOutline,
    PhoneOutline,
    EllipsisOutline,
    EyeOutline,
    DownloadOutline,
    FileSearchOutline,
    RightOutline,
    SaveOutline,
    CheckOutline,
    TrophyOutline,
    FilePdfOutline,
    SyncOutline,
    KeyOutline,
    FilterOutline,
    InboxOutline,
    CalendarOutline,
    DollarCircleOutline,
    WalletOutline,
    SwapOutline,
    LeftOutline,
    LoadingOutline,
    StopOutline,
    // Los usan el modal de vinculación (link, bank) desde siempre; faltaban en el
    // registro, así que NzIconService intentaba bajarlos y erraba en consola.
    LinkOutline,
    BankOutline,
} from '@ant-design/icons-angular/icons';

/**
 * Íconos de Ant Design registrados de forma estática en `provideNzIcons`.
 *
 * Solo se empaquetan los que usa la app; un ícono que falte aquí hace que `NzIconService` intente
 * descargarlo en runtime y registre un error en consola, así que todo ícono nuevo se agrega a esta lista.
 */
export const icons = [
    CheckSquareOutline,
    BorderOutline,
    DisconnectOutline,

    MenuFoldOutline, MenuUnfoldOutline, DashboardOutline,
    UserOutline, LockOutline, ApiOutline,
    AppstoreOutline, SafetyCertificateOutline, LogoutOutline,
    BellOutline, SettingOutline, HomeOutline,
    PlusOutline, EditOutline, DeleteOutline,
    CheckCircleOutline, CloseCircleOutline, InfoCircleOutline,
    WarningOutline, SearchOutline, ReloadOutline,
    TeamOutline, FileTextOutline, BarChartOutline, CloudUploadOutline, CloudDownloadOutline,
    FileDoneOutline, RiseOutline, ClockCircleOutline, ExclamationCircleOutline,
    ThunderboltOutline, TagOutline, QuestionCircleOutline, MinusCircleOutline, MailOutline, PhoneOutline, EllipsisOutline,
    EyeOutline, DownloadOutline, FileSearchOutline, RightOutline,
    SaveOutline, CheckOutline, TrophyOutline, FilePdfOutline,
    SyncOutline, KeyOutline, FilterOutline, InboxOutline,
    CalendarOutline, DollarCircleOutline, WalletOutline, SwapOutline,
    LeftOutline, LoadingOutline, StopOutline,
    LinkOutline, BankOutline,
];
